import { render } from "./HeaderDivider.vue?vue&type=template&id=a2b571f2&scoped=true&ts=true"
import script from "./HeaderDivider.vue?vue&type=script&lang=ts"
export * from "./HeaderDivider.vue?vue&type=script&lang=ts"

import "./HeaderDivider.vue?vue&type=style&index=0&id=a2b571f2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2b571f2"]])

export default __exports__